module.exports = __webpack_public_path__ + "img/grand-palm-hotel-3.860f87be.jpg";